import PropTypes from 'prop-types';

import Pagination from 'components/Pagination';

import { sendEvent } from 'lib/gtag';
import { toForumLink } from 'lib/links';

const onPaginationFirstButtonClick = (gaEventCategory) =>
  sendEvent({ category: gaEventCategory, action: 'first_page' });

const onPaginationLastButtonClick = (gaEventCategory) =>
  sendEvent({ category: gaEventCategory, action: 'last_page' });

const onPaginationItemsClick = (gaEventCategory) =>
  sendEvent({ category: gaEventCategory, action: 'select_number' });

/**
 * This is necessary because the Forum Home shows the same content of
 * /forum/recentes
 */
const getForumSlugToAvoidDuplicatedLinks = (slug, page) =>
  slug === 'recentes' && page === 1 ? '' : slug;

const ThreadsListPagination = ({
  basePaginationSlug,
  total,
  threadsPage,
  gaEventCategory,
}) => (
  <Pagination
    hrefFn={(currentPage) =>
      toForumLink({
        categorySlug: getForumSlugToAvoidDuplicatedLinks(
          basePaginationSlug,
          currentPage
        ),
        page: currentPage,
      })
    }
    page={threadsPage}
    total={total}
    onFirstButtonClick={() => onPaginationFirstButtonClick(gaEventCategory)}
    onItemsClick={() => onPaginationItemsClick(gaEventCategory)}
    onLastButtonClick={() => onPaginationLastButtonClick(gaEventCategory)}
  />
);

ThreadsListPagination.propTypes = {
  basePaginationSlug: PropTypes.string.isRequired,
  categoryTitle: PropTypes.string.isRequired,
  gaEventCategory: PropTypes.string.isRequired,
  threadsPage: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
};

export default ThreadsListPagination;
